// import enum
import { StatusEnum } from "@/enum/status.enum.js";

export const state = {
  filterService: {
    name: "",
    isFilter: false
  }
};
export const mutations = {
  ADD_FILTER_SERVICE: (state, data) => {
    state.filterService = data;
    state.filterService.isFilter = true;
  },
  CLEAR_FILTER_SERVICE: (state) => {
    state.filterService = {
      name: ""
    };
  },
};
export const getters = {
  GET_FILTER_SERVICE: (state) => {
    // console.log("GET_FILTER_SERVICE", state.filterService);
    return state.filterService;
  },
};
export const actions = {
  ADD_FILTER_SERVICE: ({ commit }, data) => {
    commit("ADD_FILTER_SERVICE", data);
  },
  CLEAR_FILTER_SERVICE: ({ commit }) => {
    commit("CLEAR_FILTER_SERVICE");
  },
};
